import React, { useContext } from "react";
import LimitedSelect from "./LimitedSelect";
import MunicipalityContext from "../MunicipalityContext";

export default function MunicipalitySelect({
  selectedMunicipalities,
  onChange,
  maxSelections,
  locale,
}) {
  const municipalities = useContext(MunicipalityContext);

  const municipalityOptions = municipalities =>
    municipalities.map(m => ({
      label: locale === "fi" ? m.kuntaNimi : m.kuntaNimiSv,
      value: m.kuntaKoodi,
    }));

  const compareMunicipalityOptions = (a, b) => {
    if (a.label < b.label) return -1;
    if (a.label > b.label) return 1;
    return 0;
  };

  return (
    <LimitedSelect
      onChange={onChange}
      options={municipalityOptions(municipalities).sort(
        compareMunicipalityOptions
      )}
      placeholder="refrigerationSearch.chooseMunicipalities"
      value={selectedMunicipalities}
      maxSelections={maxSelections}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/MunicipalitySelect.js